import styled, { css } from 'styled-components';
import { desktopHover, pxtorem } from '~/utils/tools';

const ButtonCSS = css`
  font-family: var(--primaryFont);
  font-size: ${pxtorem(16)};
  color: var(--black);
  text-transform: capitalize;
  font-weight: 400;

  border: 1px solid var(--text);
  padding: 15px 26px;
  border-radius: 114px;
  transition: 0.25s;
  transition-property: border, background, color;

  ${desktopHover(`
    background: var(--black);
    border-color: var(--black);
    color: var(--white);
  `)}
`;

export const StyledYotpoReviews = styled.div`
  padding: 40px 0px;

  .yotpo-hidden-mobile:nth-of-type(3) {
    display: inline !important;

    .yotpo-icon-button-text {
      display: inline !important;
    }
  }

  h3 {
    text-align: center;
    font-family: var(--secondaryFont);
    font-style: italic;
    font-size: ${pxtorem(60)};
    font-weight: 400;

    @media (max-width: 768px) {
      font-size: ${pxtorem(40)};
      margin-bottom: 12px;
    }
  }

  .yotpo {
    div,
    span {
      font-family: var(--primaryFont);
      font-size: ${pxtorem(16)};
      color: var(--black);
    }
  }

  .yotpo.yotpo-main-widget {
    .yotpo-label {
      display: none;
    }
    .yotpo-regular-box {
      border-top: none;
    }

    .yotpo-bottomline {
      max-width: 400px;

      margin: 0 auto;

      .yotpo-stars-and-sum-reviews {
        text-align: center;
      }

      .yotpo-sum-reviews {
        display: block;
        text-align: center;
      }

      &.yotpo-bottomline-2-boxes {
        .yotpo-bottomline-box-1 {
          min-width: none;
        }
      }
    }

    .yotpo-default-button {
      background-color: transparent;
    }

    .primary-color-btn {
      ${ButtonCSS};
      color: var(--white);
      background-color: var(--black);

      &:hover {
        background: transparent !important;
        border: 1px var(--black) solid !important;
        color: var(--black);
      }
    }

    .yotpo-icon-btn {
      .yotpo-icon {
        display: none;
      }
      .yotpo-icon-button-text {
        ${ButtonCSS}
      }
    }

    .write-review {
      max-width: 660px;
      margin: 0 auto;
      .yotpo-mandatory-mark {
        color: var(--red);
      }
      padding: 2rem;
      background-color: var(--gray);
      border-radius: 10px;
      .yotpo-header h2 {
        font-size: ${pxtorem(24)};
        font-weight: 400;
        margin-bottom: 0;
        color: var(--black);
        text-transform: capitalize;
      }
      .connect-wrapper {
        padding-left: 0;
      }
      .socialize-wrapper {
        display: none !important;
      }
      .y-label {
        font-size: ${pxtorem(16)};
        font-weight: 400;
        color: var(--black);
      }
      input {
        border: none;
        border-bottom: 1px solid var(--black);
      }
    }

    .yotpo-reviews {
      margin-top: ${pxtorem(80)};
    }

    .yotpo-nav {
      display: none;
    }

    .yotpo-review {
      background: var(--gray);
      border-radius: var(--radius);
      padding: 30px 60px;
      margin-bottom: ${pxtorem(20)};

      .yotpo-header {
        display: flex;
        justify-content: space-between;
        .yotpo-review-stars {
          margin-top: 0;
          margin-left: 20px;
        }
      }

      .yotpo-header-element {
        display: flex;
        align-items: center;

        .yotpo-clr {
          clear: none;
        }
        .y-label,
        .y-label.yotpo-user-name {
          color: var(--black);
          font-size: ${pxtorem(16)};
        }
      }

      .yotpo-icon-profile {
        display: none;
      }

      .yotpo-main {
        margin-left: 0;
        margin-top: 20px;

        .content-title {
          color: var(--black);
          font-size: ${pxtorem(20)};
          font-weight: 400;
          margin-bottom: ${pxtorem(5)};
        }

        .content-review {
          color: var(--black);
        }
      }

      .yotpo-footer {
        display: none;
      }
      .label-with-tooltip {
        display: none;
      }

      @media (max-width: 769px) {
        padding: 22px 30px;
      }
    }
  }

  @media (min-width: 768px) {
    padding-block: 90px;
    padding: 40px 20px;
  }
`;
